<template>
  <div id="app">
    <div class="wrap">
      <h1>Alex Barabash</h1>
      <div class="type-wrap">
        <div id="typed-strings">
          <!--
            It is important to preserve this formatting, because Typed.js
            adds additional pauses for any whitespaces or newlines.
          -->
          <!--prettyhtml-ignore-->
          <p>
            Hi!
            My name is <span class="name">Alex</span>.
            <br />I am a <span class="title">Full Stack Web Developer</span> from <span class="location">Moscow</span>.
            <br />If you want to contact me, please send me an email to <a
  href="mailto:alex@baraba.sh"
  target="_blank"
  class="email"
>alex@baraba.sh</a>
          </p>
        </div>
        <span id="typed"></span>
      </div>
      <div class="footer">
        <span id="copyright">&copy; {{ new Date().getFullYear() }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Typed from 'typed.js'

export default {
  name: 'app',
  mounted() {
    const options = {
      stringsElement: '#typed-strings',
      typeSpeed: 30,
      loop: false,
      contentType: 'html',
      loopCount: false,
    }
    // eslint-disable-next-line
    const typed = new Typed("#typed", options)

    // eslint-disable-next-line
    console.log("Hello! :)") // what's up
  },
}
</script>

<style lang="scss">
@font-face {
  font-family: "Inconsolata";
  src: url("./assets/fonts/Inconsolata-Regular.ttf") format("ttf");
}

* {
  padding: 0;
  margin: 0;
}

body {
  font-family: "Inconsolata", monospace;
  font-size: 100%;
  background: #333;
  color: #f1f1f1;
}

p {
  line-height: 2em;
  margin: 0 0 20px;
  text-align: center;
}

.wrap {
  max-width: 640px;
  margin: 20vh auto;

  h1 {
    text-align: center;
  }
}

.type-wrap {
  margin: 10px auto;
  padding: 20px;
  background: #2a2a2a;
  border-radius: 5px;
  border: #353535 1px solid;
  font-size: 1.35em;

  .name {
    color: #ffa700;
  }
  .title {
    color: #3aca54;
  }
  .location {
    color: #d44a4a;
  }
  a {
    color: #5ad;
  }
  .bullet {
    font-size: 0.7em;
  }
}

span.typed-cursor.typed-cursor--blink {
  opacity: 1;
  animation: blink 1s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.footer {
  margin: 20px 0;
  font-size: 0.75em;
  text-align: center;
}
</style>
